import type { SVGProps } from 'react';

const SvgSequence = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M19 7h-7V5c0-.97-.7-2-2-2H6C4.35 3 3 4.35 3 6v12c0 1.65 1.35 3 3 3h13c.97 0 2-.7 2-2V9c0-.97-.7-2-2-2m-4 12h-2v-1h2zM6 9h1v1H6c-.55 0-1-.45-1-1v-.18c.31.11.65.18 1 .18m5 0v1H9V9zm-1 7v-4h4v4zm3-6V9h2v1zm-8 1.82c.31.11.65.18 1 .18h2v4H6c-.55 0-1-.45-1-1zM11 18v1H9v-1zm5-2v-4h3v4zm3-6h-2V9h2zM6 5h4v2H6c-.55 0-1-.45-1-1s.45-1 1-1M5 18v-.18c.31.11.65.18 1 .18h1v1H6c-.55 0-1-.45-1-1m12 1v-1h2v1z"
    />
  </svg>
);
export default SvgSequence;
